<template>
  <div>
    <span>
      <v-menu v-if="user && $can(['aulas.mudarSituacao'])" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-chip label :color="color" class="text-center" x-small v-bind="attrs" v-on="on">
            {{ descricaoSituacao }}
          </v-chip>
        </template>
        <v-list>
          <v-list-item
            v-for="situacao of $constants.situacoesAulas"
            :key="situacao.descricao"
            link
            @click="() => verificarMotivo(situacao.descricao)"
          >
            <v-list-item-title>{{ situacao.descricao }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-chip v-else label :color="color" x-small>
        {{ descricaoSituacao }}
      </v-chip>
    </span>
    <v-progress-linear
      v-show="atualizando"
      indeterminate
      striped
      color="primary"
    ></v-progress-linear>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="primary">
          <span class="text-h5 white--text">Informar motivo</span>
        </v-card-title>
        <v-col cols="12">
          <v-textarea
            filled
            autofocus
            v-model="motivo"
            label="Descreva o motivo"
            dense
            solo
          ></v-textarea>
        </v-col>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="dialog = false"> Cancelar </v-btn>
          <v-btn color="primary" text @click="() => alterarSituacao(situacaoComMotivo, motivo)">
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    atendimento: {
      type: Object,
      required: true,
    },
    i: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      atualizando: false,
      descricaoSituacao: this.atendimento.descricaoSituacao,
      color: this.atendimento.color,
      dialog: false,
      motivo: null,
      situacaoComMotivo: null,
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
  },
  methods: {
    verificarMotivo(novaSituacao) {
      if (novaSituacao === "Aula inválida" || novaSituacao === "Aula rejeitada por falta") {
        this.motivo = this.atendimento.motivo;
        this.situacaoComMotivo = novaSituacao;
        this.dialog = true;
        return;
      }
      this.alterarSituacao(novaSituacao, null);
    },
    async alterarSituacao(novaSituacao, motivo) {
      this.dialog = false;
      this.atualizando = true;
      try {
        const atendimentoAtualizado =
          await this.$services.educacaoInclusivaService.atualizarSituacao(
            this.atendimento.id,
            novaSituacao,
            motivo
          );
        this.descricaoSituacao = atendimentoAtualizado.descricaoSituacao;
        this.color = atendimentoAtualizado.color;
        this.$emit("alterarSituacao", { atendimentoAtualizado, i: this.i });
      } catch (error) {
        this.$handleError(error);
      }
      this.atualizando = false;
    },
  },
};
</script>
